import axios from "axios";
import { baseURL } from "@/general";

const adminApi = axios.create({
  baseURL,
});

export const LoginUser = async (values) => {
  try {
    const response = await adminApi.post("/general/login", values);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const VerificaToken = async (token, values) => {
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post("/general/perfil", values, config);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const verificaTokenCuenta = async (token) => {
  try {
    const response = await adminApi.post("/general/validarToken", token);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const establecerContraseña = async (values) => {
  try {
    const response = await adminApi.post("general/setPassword", values);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const olvidoPassword = async (values) => {
  try {
    const response = await adminApi.post("general/forgottenPassword", values);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const cambiarConstraseña = async (values) => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post(
      "general/resetPassword",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

// Catalogo carreras
export const getCarrerasService = async () => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.get("/carrera/getCarreras", config);
    return response;
  } catch (error) {
    const response = error;
    return response;
  }
};

// Catalogo estancias
export const getEstanciasService = async () => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.get(
      "/estancia/getCatalogoEstancias",
      config
    );
    return response;
  } catch (error) {
    const response = error;
    return response;
  }
};

//Insertar estancias
export const insertarEstancias = async (values) => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post("estancia/insert", values, config);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};


//Editar estancias
export const updateEstancias = async (values) => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post("estancia/update", values, config);
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};


//Comprobar RFC de adjunto
export const verificaAdjunto = async (values) => {  
  try {
    const response = await adminApi.post("investigador/validaRFC", values);
    return response.data;
  } catch (error) {
    const response = error.response;
    return response;
  }
};